define.alias("shared/components/shared/ui/banner", "preview-grid/components/shared/ui/banner");